export enum SessionScreenshotSubject {
    ParticipantVideo = 'participant-video',
    LocalScreen = 'local-screen',
    LocalVideo = 'local-video',
}
